import React from "react";

export default function SelectInput({
  label,
  value,
  onChange,
  onBlur,
  options = [],
  loading = false,
  placeholder = "Select an option",
  error,
}) {
  return (
    <div className="form-group mb-3">
      {label && <label className="form-label fw-semibold mb-1 text-lg">{label}</label>}
      <select
        value={value || ""}
        onChange={onChange}
        onBlur={onBlur}
        disabled={loading}
        className={`form-select ${error ? "is-invalid" : ""}`}
      >
        <option value="">{placeholder}</option>
        {loading ? (
          <option disabled>Loading...</option>
        ) : (
          options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))
        )}
      </select>
      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
}
